import type { Transfer, TransferInput } from 'generated/gql';

import { mapShareSeriesToShareSeriesInput } from './ShareSeries';

export const mapTransferToTransferInput = (transfer: Transfer): TransferInput => ({
  fromPartyId: transfer.from.id,
  toPartyId: transfer.to?.id,
  shareSeries: mapShareSeriesToShareSeriesInput(transfer.shareSeries),
});
